import { tokens } from "../../../../theme";
import { Box, Checkbox, Typography, useTheme } from "@mui/material";
import { refreshDrawerStyles } from "./styles";
import { SCOPE_FLAGS, enabledScopeCount } from "./helpers";

// Same four flags in two skins: a checklist for Standard, checkbox chips for
// Custom. The base config branch lives in the Target card, not here — it picks
// *where config comes from* rather than how much of the environment is touched.
const ScopeCard = ({
  title,
  description,
  variant = "checklist",
  scope,
  setScope,
}) => {
  const theme = useTheme();
  const { refreshDrawer } = refreshDrawerStyles(tokens(theme.paletteId));
  const toggle = (key) => setScope((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <Box sx={refreshDrawer.card}>
      <Box sx={{ ...refreshDrawer.cardHead, alignItems: "flex-start" }}>
        <Box sx={refreshDrawer.cardHeadText}>
          <Typography sx={refreshDrawer.cardTitle}>{title}</Typography>
          {description ? (
            <Typography sx={refreshDrawer.cardHeadDescription}>
              {description}
            </Typography>
          ) : null}
        </Box>
        <Typography sx={refreshDrawer.cardCount}>{`${enabledScopeCount(
          scope
        )}/${SCOPE_FLAGS.length}`}</Typography>
      </Box>
      <Box sx={refreshDrawer.cardBody}>
        {variant === "chips" ? (
          <Box sx={refreshDrawer.chipRow}>
            {SCOPE_FLAGS.map(({ key, label, description: hint }) => (
              <Box
                key={key}
                component="label"
                title={hint}
                sx={refreshDrawer.checkChip(Boolean(scope[key]))}
              >
                <Checkbox
                  disableRipple
                  size="small"
                  checked={Boolean(scope[key])}
                  onChange={() => toggle(key)}
                  sx={refreshDrawer.checkChipBox}
                />
                {label}
              </Box>
            ))}
          </Box>
        ) : (
          <Box sx={refreshDrawer.checklist}>
            {SCOPE_FLAGS.map(({ key, label, description: hint }) => (
              <Box key={key} component="label" sx={refreshDrawer.checkRow}>
                <Checkbox
                  disableRipple
                  size="small"
                  checked={Boolean(scope[key])}
                  onChange={() => toggle(key)}
                  sx={refreshDrawer.checkbox}
                />
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={refreshDrawer.checkLabel}>{label}</Typography>
                  <Typography sx={refreshDrawer.checkDescription}>
                    {hint}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ScopeCard;
